import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { ChatBatchResult } from '../ChatBatchResult'

@InputType()
export class BatchUpdateChatRemarksArgs extends ActionArgs {
  @Field(() => [ID])
  chatIds: string[]

  @Field(() => String)
  remarks: string
}

export interface IBatchUpdateChatRemarks extends IAction<ChatBatchResult, BatchUpdateChatRemarksArgs> {}
